import queryKeys from '@/constants/queryKeys';
import { restoreAdminContent } from '@/services/api/requests/content';
import { TCustomAxiosError } from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';

const useRestoreContent = (id: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  const { isPending, isSuccess, mutate } = useMutation({
    mutationFn: async () => {
      const response = await restoreAdminContent(id);
      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.byId, id] });
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.all] });
      toast({ status: 'success', title: 'Success', description: 'Content restored.' });
      onSuccess?.();
    },
    onError: async (error: TCustomAxiosError) => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.byId, id] });
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.all] });
      toast({
        status: 'error',
        title: 'Error restoring content',
        description: error.errors?.[0]?.message,
      });
    },
  });

  return { isPending, isSuccess, mutate };
};

export default useRestoreContent;
